var Progress = /** @class */ (function () {
    function Progress(pCallback, pMultipleSections) {
        if (pCallback === void 0) { pCallback = null; }
        if (pMultipleSections === void 0) { pMultipleSections = false; }
        this.mSectionSize = 0;
        this.mSectionProgress = 0;
        this.mBaseProgress = 0;
        this.mProgress = 0;
        this.mCallback = pCallback;
        if (!pMultipleSections) {
            this.startSection(100);
        }
    }
    Object.defineProperty(Progress.prototype, "progress", {
        get: function () {
            return (this.mProgress);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Progress.prototype, "sectionProgress", {
        get: function () {
            return (this.mSectionProgress);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets the current progress. If multiple sections are used the progress for the
     * current section will be set.
     * @param pProgress The new progress in percent. (range: [0, 100])
     */
    Progress.prototype.setProgress = function (pProgress) {
        if (this.mSectionProgress == pProgress)
            return;
        this.mSectionProgress = pProgress;
        var tAbsoluteProgress = this.mSectionProgress * (this.mSectionSize / 100.0);
        this.mProgress = this.mBaseProgress + tAbsoluteProgress;
        if (this.mCallback != null)
            this.mCallback(this.mProgress);
    };
    /**
     * Starts a new progress section and finishes previous one.
     * @param pSize Size of the section in percent.
     */
    Progress.prototype.startSection = function (pSize) {
        //finishe current section
        this.finishSection();
        this.mSectionSize = pSize;
    };
    Progress.prototype.finishSection = function () {
        //trigger callback
        this.setProgress(100);
        this.mBaseProgress += this.mSectionSize;
        this.mProgress = this.mBaseProgress;
        this.mSectionSize = 0;
        this.mSectionProgress = 0;
    };
    return Progress;
}());
export { Progress };
export default Progress;
